/* jscs:disable maximumNumberOfLines */
'use strict';

angular.module('AcaApp').controller('RecordController', [
  '$rootScope',
  '$scope',
  '$filter',
  '$mdDialog',
  '$window',
  '$routeParams',
  '$location',
  'ParticipantService',
  'EmployerService',
  'LayoutService',
  'FormService',
  'HomeService',
  'LockedScreenService',
  'EXCEPTION',
  'ReportService',
  '$http',
  'UtilsService',
  'PARTICIPANT_FORM',
  // jscs:disable maximumLineLength
  function($rootScope, $scope, $filter, $mdDialog, $window, $routeParams, $location, ParticipantService, EmployerService, LayoutService, FormService, HomeService, LockedScreenService, EXCEPTION, ReportService, $http, UtilsService, PARTICIPANT_FORM){
    LockedScreenService.disableAutomaticOpenWindow();
    $scope.currentParticipant = {};
    $scope.participantByMR = {};
    $scope.formByRecno = {};
    $scope.filterParticipant = {};
    $scope.participantFiltered = {};
    $scope.searchRecord = {};
    $scope.recordPage = 'main';
    $scope.currentEntity = 'participant';
    $scope.nextRecords = false;
    $scope.searchShow = true;
    $scope.formOrigin = '';
    $scope.editDisabled = false;
    LayoutService.addFloatLayer('#trigger-new-record', '#layer-new-record');
    LayoutService.addFloatLayer('#trigger-show-record', '#layer-show-record');
    $scope.sidebar = false;
    $scope.fixRecords = false;
    $scope.isReportActive = false;
    $scope.isSearch = false;
    $scope.taxyear = $window.sessionStorage.taxYear;
    var avoidNullification = -2147483648;
    $scope.$watch('[sidebar, recordPage, reportPage]', function(){
      if($scope.sidebar && ($scope.recordPage === 'main' ||$scope.recordPage === 'reports')){
        LayoutService.setBody('left-column-gray');
      }
      else{
        LayoutService.setBodyByDefault();
      }
    });

    var loadUserRecordsInfomation = function(){
      HomeService.getInformationHome().then(function(data){
        var result = data.result;
        // jscs:disable maximumLineLength, disallowImplicitTypeConversion
        $scope.numpayerrows = result.numpayerrows;
        $scope.numtotalpayeerows = result.numtotalpayeerows;
        $scope.numtotalx5bformrows = result.numtotalx5bformrows;
        $scope.numtotalx5cformrows = result.numtotalx5cformrows;
        $scope.totalIncompleteRecords = result.numincompletex5cformrows + result.numincompletepayeerows + result.numincompletex5bformrows;
        $scope.hasIncompleteRecords = $scope.totalIncompleteRecords > 0;
      });
    };

    var setParticipantData = function(data){
      $scope.participants = ParticipantService.addExtraItemsOnParticipant(data.result);
      $scope.nextRecords = (data.result.length > 0) ? true : false;
      generateFullName(data.result);
    };

    var loadParticipantsList = function(){
      ParticipantService.getParticipantRecords().then(setParticipantData);
    };

    var setEmployerData = function(data){
      $scope.employers = data.result;
      $scope.nextRecords = (data.result.length > 0) ? true : false;
      generateFullName(data.result);
    };

    var loadEmployersList = function(){
      EmployerService.GetEmployerRecords().then(setEmployerData);
    };

    var loadFixParticipantsList = function(){
      ParticipantService.getFixParticipantRecords().then(setParticipantData);
    };

    var boldEntityTitle = function(entity){
      if(entity === 'participant'){
        $scope.selectedParticpant = true;
        $scope.selectedEmployer = false;
      }
      else{
        $scope.selectedParticpant = false;
        $scope.selectedEmployer = true;
      }
    };

    var loadRecordsByEntity = function(entity){
      if(entity === 'participant'){
        if($scope.fixRecords){
          loadFixParticipantsList();
        }
        else{
          loadParticipantsList();
        }
      }
      else{
        loadEmployersList();
      }
    };

    $scope.goToFixRecords = function(){
      $scope.recordPage = 'main';
      $scope.sidebar = true;
      $scope.fixRecords = true;
      $scope.currentEntity = 'participant';
      boldEntityTitle($scope.currentEntity);
      $scope.getFixParticipantRecords();
      $scope.searchShow = false;
      $scope.isReportActive = false;
    };

    $scope.goToAllRecords = function(){
      $scope.recordPage = 'main';
      $scope.sidebar = false;
      $scope.fixRecords = false;
      loadParticipantsList();
      $scope.searchShow = true;
    };

    $scope.isSidebarActive = function(){
      return $scope.sidebar;
    };

    $scope.changeEntity = function(entity){
      LockedScreenService.disableAutomaticOpenWindow();
      boldEntityTitle(entity);
      loadRecordsByEntity(entity);
      $scope.currentEntity = entity;
    };

    $scope.onOrderChange = function(order){
      $scope.participants = $filter('orderBy')($scope.participants, order);
      return $scope.participants;
    };

    $scope.onOrderEmployer = function(order){
      $scope.employers = $filter('orderBy')($scope.employers, order);
      return $scope.employers;
    };

    $scope.loadDefaultRecordsInformation = function(){
      loadParticipantsList();
      loadUserRecordsInfomation();
    };

    $scope.loadDefaultRecordsInformation();

    $scope.getFixParticipantRecords = function(){
      loadFixParticipantsList();
      if(!$scope.sidebar){
        loadUserRecordsInfomation();
      }
    };

    $scope.ParticipantModal = function(event, action){
      $scope.participantAction = action;
      $scope.participantByMR = (_.isEmpty($scope.participantByMR)) ? undefined : $scope.participantByMR;
      $mdDialog.show({
        scope: $scope.$new(),
        preserveScope: true,
        templateUrl: PARTICIPANT_FORM[UtilsService.getTaxYear()],
        parent: angular.element(document.body),
        controller: 'ParticipantController',
        targetEvent: event,
        locals: {
          currentParticipant: $scope.participantByMR
        }
      });
    };

    $scope.EmployerModal = function(event, action){
      $scope.employerAction = action;
      $scope.employerByPk = (_.isEmpty($scope.employerByPk)) ? undefined : $scope.employerByPk;
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/employer/modals/form-employer.html',
        parent: angular.element(document.body),
        controller: 'EmployerController',
        targetEvent: event,
        locals: {
          currentEmployer: $scope.employerByPk
        }
      });
    };

    $scope.AddParticipant = function(event){
      $scope.participantByMR = {};
      $scope.ParticipantModal(event, 'add');
    };

    $scope.EditParticipant = function(event, modrecno){
      $scope.participantByMR = {};
      ParticipantService.getParticipantByModRecno(modrecno).then(
        function(data){
          $scope.participantByMR = data.result;
          $scope.ParticipantModal(event, 'edit');
        },
        function(){
          alert('Error');
        }
      );
    };

    $scope.ErrorMsg = function(error){
      /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
      if(error.data.error.frontend_code === EXCEPTION.PARTRELATEDFORMRECORDS){
        $mdDialog.show({
          scope: $scope.$new(),
          templateUrl: 'app/views/participant/modals/deleteParticipant-error.html',
          parent: angular.element(document.body)
        });
      }
      if(error.data.error.frontend_code === EXCEPTION.EMPRELATEDFORMRECORDS){
        $mdDialog.show({
          scope: $scope.$new(),
          templateUrl: 'app/views/employer/modals/deleteEmployer-error.html',
          parent: angular.element(document.body)
        });
      }
      if(error.data.error.frontend_code === EXCEPTION.FORMSTRANSMITTED){
        $mdDialog.show({
          scope: $scope.$new(),
          templateUrl: 'app/views/form/modals/delete-form-xmit-error.html',
          parent: angular.element(document.body)
        });
      }
    };

    $scope.deleteParticipant = function(){
      ParticipantService.Delete($scope.participantByMR).then(function(){
        $mdDialog.hide();
        $scope.recordPage = 'participant-deleted';
      },
      function(error){
        $scope.ErrorMsg(error);
      });
    };

    $scope.deleteForm = function(){
      if($scope.fcharForm == "'X5B'"){
        AreThereX5BPrinted();
      }
      if($scope.fcharForm == "'X5C'"){
        AreThereX5CPrinted();
      }
    };

    var AreThereX5BPrinted = function(){
      $scope.formX5 = {};
      $scope.formX5 = $scope.formByRecno;
      $scope.formX5.ptin = $scope.formRecno.ptin;
      $scope.formX5.fk2 = $scope.formRecno.fk2;
      $scope.formX5.c14 = $scope.formRecno.c14;
      $scope.formX5.s01 = $scope.formRecno.s01;

      FormService.areThereX5BPrinted($scope.formX5).then(function(data){
        checkPrinted(data.result.value);
      });
    };

    var AreThereX5CPrinted = function(){
      $scope.formX5 = {};
      $scope.formX5 = $scope.formByRecno;
      $scope.formX5.ptin = $scope.formRecno.ptin;
      $scope.formX5.fk2 = $scope.formRecno.fk2;
      FormService.areThereX5CPrinted($scope.formX5).then(function(data){
        checkPrinted(data.result.value);
      });
    };

    var formMapped = function(){
      var form1095 = {};
      form1095.ptin = $scope.formRecno.ptin;
      form1095.tin = $scope.formRecno.fk1;
      form1095.accountno = $scope.formRecno.fk2;
      form1095.recno = $scope.formRecno.recno;
      form1095.status = $scope.formRecno.status;
      form1095.recordversion = $scope.formRecno.recordversion;
      if($scope.formRecno.stmtrun === undefined){
        $scope.formRecno.stmtrun = avoidNullification;
      }
      form1095.stmtrun = $scope.formRecno.stmtrun;
      form1095.noxmit = $scope.formRecno.noxmit !== 'Y' ? 'Y' : 'N';
      form1095.xmitrun = $scope.formRecno.xmitrun;
      form1095.groupstatus = $scope.formRecno.s03;
      if($scope.fcharForm == "'X5B'"){
        form1095.originofpolicy = $scope.formRecno.c14;
        form1095.employersponsor = $scope.formRecno.s01;
      }
      return form1095;
    };

    var doExclude = function(){
      var excludeFunctionName = $scope.fcharForm === "'X5B'" ? 'exclude1095B' : 'exclude1095C';
      FormService[excludeFunctionName](formMapped()).then(
        function(data){
          if(data.result.value){
            $mdDialog.hide();
            $rootScope.isRefresh = 'refreshForm';
          }
        },
        function(error){
          $scope.ErrorMsg(error);
        }
      );
    };

    $scope.excludeCheckPrinted = function(){
      if($scope.formRecno.stmtrun !== undefined && $scope.formRecno.status === 'D'){
        $mdDialog.show({
          templateUrl: 'app/views/form/modals/printCorrection.html',
          preserveScope: true,
          scope: $scope
        });
      }
      else{
        doExclude();
      }
    }

    $scope.isSubscriberExcluded = function(form){
      FormService.isSubscriberExcluded(form.recno, form.fchar).then(
        function(data){
          var isExcluded = data.result.value === 'Y' ? true : false;
          if(isExcluded){
            $mdDialog.show({
              scope: $scope.$new(),
              templateUrl: 'app/views/form/modals/printpreview-form-excluded.html',
              parent: angular.element(document.body),
            });
          }
          else{
            $scope.relay(form);
          }
        },
        function(error){
          $scope.ErrorMsg(error);
        }
      );
    };

    $scope.isNoXmitChecked = function(form){
      return form.noxmit === 'Y' ? true : false;
    };

    var checkPrinted = function(isPrinted){
      if(isPrinted > 0){
        $mdDialog.show({
          templateUrl: 'app/views/participant/modals/updateConfirmation.html',
          scope: $scope,
          preserveScope: true
        });
      }
      else{
        $scope.formX5.stmtrun = avoidNullification;
        doDelete();
      }
    };

    var doDelete = function(){
      FormService.Delete($scope.formX5).then(function(){
        $mdDialog.hide();
        $scope.recordPage = 'form-deleted';
      },
      function(error){
        $scope.ErrorMsg(error);
      });
    };

    $scope.reprintCancel = function(){
      $mdDialog.hide();
    };

    $scope.reprintYes = function(){
      $mdDialog.hide();
      if($scope.formX5 !== undefined){
        $scope.formX5.stmtrun = 0;
        doDelete();
      }
      else{
        $scope.formRecno.stmtrun = 0;
        doExclude();
      }
    };

    $scope.reprintNot = function(){
      $mdDialog.hide();
      if($scope.formX5 !== undefined){
        $scope.formX5.stmtrun = avoidNullification;
        doDelete();
      }
      else{
        doExclude();
      }
    };

    $scope.deleteEmployer = function(){
      EmployerService.DeleteEmployer($scope.employerByPk).then(function(){
        $mdDialog.hide();
        $scope.recordPage = 'employer-deleted';
      },
      function(error){
        $scope.ErrorMsg(error);
      });
    };

    $scope.deleteParticipantConfirm = function(event, modrecno){
      $scope.selectedModrecno = modrecno;
      $scope.participantByMR = {};
      ParticipantService.getParticipantByModRecno(modrecno).then(
        function(data){
          $scope.participantByMR.modrecno = data.result.modrecno;
          $scope.participantByMR.modlevel = data.result.modlevel;
          $scope.participantByMR.recordversion = data.result.recordversion;
        },
        function(){
          alert('Error');
        }
      );
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/participant/modals/delete-participant.html',
        parent: angular.element(document.body),
        targetEvent: event
      });
    };

    $scope.deleteFormConfirm = function(event, recno){
      $scope.formByRecno = {};
      $scope.selectedRecno = recno;
      $scope.fcharForm = event.currentTarget.id;
      FormService.getFormByRecno(recno).then(
        function(data){
          $scope.formByRecno.fchar = data.result.fchar;
          $scope.formByRecno.recno = data.result.recno;
          $scope.formByRecno.modlevel = data.result.modlevel;
          $scope.formByRecno.recordversion = data.result.recordversion;
          $scope.formRecno = data.result;
        },
        function(){
          alert('Error');
        }
      );
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/form/modals/delete-form.html',
        parent: angular.element(document.body),
        targetEvent: event
      });
    };

    $scope.excludeFormConfirm = function(event, recno){
      $scope.formByRecno = {};
      $scope.selectedRecno = recno;
      $scope.fcharForm = event.currentTarget.id;
      FormService.getFormByRecno(recno).then(
        function(data){
          $scope.formByRecno.fchar = data.result.fchar;
          $scope.formByRecno.recno = data.result.recno;
          $scope.formByRecno.modlevel = data.result.modlevel;
          $scope.formByRecno.recordversion = data.result.recordversion;
          $scope.formByRecno.noxmit = data.result.noxmit;
          $scope.formRecno = data.result;
          if($scope.formRecno.noxmit !== 'Y'){
            $mdDialog.show({
              scope: $scope.$new(),
              templateUrl: 'app/views/form/modals/exclude-form.html',
              parent: angular.element(document.body),
              targetEvent: event
            });
          }
          else{
            $scope.excludeCheckPrinted();
          }
        },
        function(){
          alert('Error');
        }
      );
    };

    $scope.deleteEmployerConfirm = function(event, ptin){
      event.stopPropagation();
      $scope.selectedPtin = ptin;
      $scope.employerByPk = {};
      EmployerService.GetEmployerByPk(ptin).then(
        function(data){
          $scope.employerByPk = data.result;
        },
        function(){
          alert('Error');
        }
      );
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/employer/modals/delete-employer.html',
        parent: angular.element(document.body),
        targetEvent: event
      });
    };

    $scope.AddEmployer = function(event){
      $scope.employerByPk = {};
      $scope.editDisabled = false;
      $scope.EmployerModal(event, 'add');
    };

    $scope.EditEmployer = function(event, ptin){
      $scope.employerByPk = {};
      EmployerService.GetEmployerByPkToView(ptin).then(
        function(data){
          $scope.employerByPk = data.result;
          $scope.editDisabled = true;
          $scope.EmployerModal(event, 'edit');
        },
        function(){
          alert('Error');
        }
      );
    };

    $scope.closeModal = function(){
      $mdDialog.hide();
    };

    $scope.FormModal = function(event, action, form){
      $scope.formByRecno = {};
      if(event === false) {
        event = {target: {getAttribute: function(){}}};
      }
      var formName;
      if(form !== undefined && form.fchar !== undefined){
        formName = (form.fchar === 'X5B') ? '1095B' : '1095C';
      }
      else{
        formName = event.target.getAttribute('data-form');
      }
      $scope.formAction = action;
      if(event.target.getAttribute('data-record') !== '') {
        $scope.formOrigin = event.target.getAttribute('data-record');
      }
      else{
        $scope.formOrigin = 'menu';
      }
      if($scope.formAction === 'edit'){
        $scope.addFormModal(formName, form.status, form.recno);
      }
      else{
        if(event.target.getAttribute('data-status') !== undefined){
          form.status = event.target.getAttribute('data-status');
        }
        if(form.status !== 'D'){
          $scope.showForm(formName, '');
        }
        else{
          $scope.showFormDependent(formName, 'Dependent', form.fchar);
        }
      }
    };

    $scope.addFormModal = function(formName, status, recno){
      var statusForm = (status === 'D') ? 'Dependent' : '';
      if(formName == '1095B'){
        FormService.get1095BForms(recno).then(
          function(data){
            $scope.formByRecno = data.result;
            $scope.showForm(formName , statusForm);
          },
          function(error){
            showUnassociatedDependentModal(error.data.error.frontend_code);
          }
        );
      }
      else{
        if(formName == '1095C'){
          FormService.get1095CForms(recno).then(
            function(data){
              $scope.formByRecno = data.result;
              $scope.showForm(formName, statusForm);
            },
            function(error){
              showUnassociatedDependentModal(error.data.error.frontend_code);
            }
          );
        }
      }
    };

    var showUnassociatedDependentModal = function(code){
      if(code === EXCEPTION.RECORDNOTFOUND){
        $mdDialog.show({
          scope: $scope.$new(),
          templateUrl: 'app/views/form/modals/unassociated-dependent.html',
          parent: angular.element(document.body)
        });
      }
    };

    var showUnassociatedSubscriberModal = function(code){
      if(code === EXCEPTION.RECORDNOTFOUND){
        $mdDialog.show({
          scope: $scope.$new(),
          templateUrl: 'app/views/form/modals/unassociated-subscriber.html',
          parent: angular.element(document.body)
        });
      }
    };

    var showSamePersonModal = function(code){
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/form/modals/same-person-error.html',
        parent: angular.element(document.body)
      });
    };

    var buildTemplateUrl = function(formName, statusForm){
      var base = 'app/views/form/modals/form';
      if(formName === '1095C' && statusForm !== 'Dependent' && $scope.taxyear >= 2020){
        return base + formName + statusForm + '-ty-2020.html'
      }
      return base + formName + statusForm + '.html'
    };

    $scope.showForm = function(formName, statusForm){
      var params;
      if(statusForm !== ''){
        params = {
          subscriber: undefined,
          currentForm: (_.isEmpty($scope.formByRecno)) ? undefined : $scope.formByRecno
        };
      }
      else{
        params = {
          currentForm: (_.isEmpty($scope.formByRecno)) ? undefined : $scope.formByRecno
        };
      }
      $mdDialog.show({
        scope: $scope.$new(),
        controller: 'Form' + statusForm + 'Controller',
        templateUrl: buildTemplateUrl(formName, statusForm),
        preserveScope: true,
        locals: params
      });
    };

    $scope.showFormDependent = function(formName, statusForm, fchar){
      var params;
      FormService.getSubscriberFormsByModrecno($scope.currentParticipant.modrecno, fchar).then(
        function(data){
          if($scope.currentParticipant.modrecno === data.result[0].modrecno)
          {
            showSamePersonModal();
          }
          else
          {
            params = {
              subscriber: data.result,
              currentForm: $scope.currentParticipant
            };
            $mdDialog.show({
              scope: $scope.$new(),
              preserveScope: true,
              controller: 'Form' + statusForm + 'Controller',
              templateUrl: buildTemplateUrl(formName, statusForm),
              locals: params
            });
          }
        },
        function(error){
          showUnassociatedSubscriberModal(error.data.error.frontend_code);
        }
      );
    };

    $scope.AddForm1094C = function(){
      $mdDialog.show({
        scope: $scope.$new(),
        preserveScope: true,
        controller: 'Form1094CController',
        templateUrl: 'app/views/form/modals/form1094C.html',
        locals: {
          currentEmployer: undefined
        }
      });
    };

    $scope.AddForm1094B = function(){
      $mdDialog.show({
        scope: $scope.$new(),
        controller: 'Form1094BController',
        templateUrl: 'app/views/form/modals/form1094B.html',
        locals: {
          currentEmployer: undefined
        }
      });
    };

    $scope.EditForm1094 = function(event, ptin, form){
      event.stopPropagation();
      $scope.employerByPK = {};
      EmployerService.GetEmployerByPk(ptin).then(
        function(data){
          $scope.employerByPk = data.result;
          $scope.Form1094Modal(event, form);
        },
        function(){
          alert('Error');
        }
      );
    };

    var checkSignatureDate = function(date){
      return (date !== undefined) ? UtilsService.getUnixTimestamp(date).split(' ')[0] : '';
    };

    $scope.Form1094Modal = function(event, form){
      $scope.employerByPk = (_.isEmpty($scope.employerByPk)) ? undefined : $scope.employerByPk;
      $scope.employerByPk.x4b_signaturedate = checkSignatureDate($scope.employerByPk.x4b_signaturedate);
      $scope.employerByPk.x4c_signaturedate = checkSignatureDate($scope.employerByPk.x4c_signaturedate);
      $mdDialog.show({
        scope: $scope.$new(),
        preserveScope: true,
        templateUrl: 'app/views/form/modals/form1094' + form + '.html',
        parent: angular.element(document.body),
        controller: 'Form1094' + form + 'Controller',
        targetEvent: event,
        locals: {
          currentEmployer: $scope.employerByPk
        }
      });
    };

    $scope.AddForm = function(event, form){
      $scope.FormModal(event, 'add', {fchar: form});
    };

    $scope.OpenModalFormType = function(event, fchar){
      $scope.fchar = fchar;
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/form/modals/formTypeSelection.html'
      });
    };

    $scope.EditForm = function(event, form){
      $scope.FormModal(event, 'edit', form);
    };

    $scope.SearchRecords = function(){
      $scope.searchRecord.search = ($scope.searchRecord.search === undefined) ? '' : $scope.searchRecord.search;
      if($scope.searchRecord.search.length > 0 && $scope.searchRecord.search.length < 4){
        $scope.searchRequired = true;
        $scope.isSearch = false;
        return ;
      }
      $scope.isSearch = true;
      $scope.searchRequired = false;
      searchRecords();
    };

    $scope.goParticipant = function(participant){
      ParticipantService.getForms(participant.modrecno).then(
        function(data){
          $scope.currentParticipant = participant;
          $scope.currentParticipant.forms = data.result;
          $rootScope.currentParticipant = $scope.currentParticipant;
          $scope.recordPage = 'participant';
        },
        function(error){
          console.log('Error: ', error);
        }
      );
    };

    $rootScope.goParticipant = $scope.goParticipant;

    $scope.goRecords = function(){
      if(!$scope.isSearch){
        loadRecordsByEntity($scope.currentEntity);
        loadUserRecordsInfomation();
      }
      else{
        searchRecords();
      }
      $scope.recordPage = 'main';
    };

    var searchRecords = function(){
      if($scope.currentEntity === 'participant'){
        ParticipantService.SearchParticipantRecords($scope.searchRecord.search).then(setParticipantData);
      }
      else{
        EmployerService.SearchEmployerRecords($scope.searchRecord.search).then(setEmployerData);
      }
    };

    var generateFullName = function(participant){
      if(participant.length > 0){
        _.each(participant, function(element){
          element.fullName = element.name;
          if(element.middlename !== undefined){
            element.fullName += ' ' + element.middlename;
          }
          if(element.name2 !== undefined){
            element.fullName+= ' ' + element.name2;
          }
          if(element.namesuffix !== undefined && UtilsService.getTaxYear().indexOf("2015") < 0 ){
            element.fullName+= ' ' + element.namesuffix;
          }
        });
      }
    };

    $rootScope.$watch('isRefresh', function(){
      switch($rootScope.isRefresh){
        case 'updateEmployer':
          loadEmployersList();
          $rootScope.isRefresh = '';
          break;
        case 'refreshForm':
          if($rootScope.currentParticipant){
            generateFullNameAndTinMask();
            $rootScope.goParticipant($rootScope.currentParticipant);
          }
          $rootScope.isRefresh = '';
          break;
        case 'updateParticipant':
          if($rootScope.currentParticipant.modrecno){
            ParticipantService.getParticipantByModRecno($rootScope.currentParticipant.modrecno).then(
              function(data){
                $rootScope.currentParticipant = data.result;
                $rootScope.goParticipant($rootScope.currentParticipant);
                generateFullNameAndTinMask();
                $rootScope.currentParticipant.tinWithoutSuffix = ParticipantService.removeSuffixOnTin($rootScope.currentParticipant.tin);
              },
              function(){
                alert('Error');
              }
            );
          }
          $rootScope.isRefresh = '';
          break;
      }
    });

    var generateFullNameAndTinMask = function(){
      $rootScope.currentParticipant.fullName = $rootScope.currentParticipant.name;
      if($rootScope.currentParticipant.middlename !== undefined){
        $rootScope.currentParticipant.fullName += ' ' + $rootScope.currentParticipant.middlename;
      }
      if($rootScope.currentParticipant.name2 !== undefined){
        $rootScope.currentParticipant.fullName+= ' ' + $rootScope.currentParticipant.name2;
      }
      if($rootScope.currentParticipant.namesuffix !== undefined && UtilsService.getTaxYear().indexOf("2015") < 0){
        $rootScope.currentParticipant.fullName+= ' ' + $rootScope.currentParticipant.namesuffix;
      }
      $rootScope.currentParticipant.tinWithMask = ParticipantService.maskTin($rootScope.currentParticipant.tin);
    };

    $scope.checkRouteParams = function(){
      var section = $routeParams.section;
      switch(section) {
        case 'fix':
          $scope.goToFixRecords();
          break;
        case 'participant':
          $scope.AddParticipant();
          break;
        case 'employer':
          $scope.AddEmployer();
          break;
        case '1095B':
          $scope.FormModal(false, 'add', {fchar: 'X5B'});
          break;
        case '1095C':
          $scope.FormModal(false, 'add', {fchar: '1095C'});
          break;
        case '1094B':
        case '1094C':
          section = 'AddForm' + section;
          $scope.changeEntity('employer');
          $scope[section]();
          break;
        case 'recordEmployer':
          $scope.changeEntity('employer');
          break;
      }
    };

    boldEntityTitle($scope.currentEntity);
    $scope.checkRouteParams();

    $scope.goCreateReports = function(){
      $scope.recordPage = 'report';
      $scope.sidebar = true;
      $scope.isReportActive = true;
    };

    var sendRelayRequest = function(params, recno){
      $('#relay_params_' + recno).val(params);
      $('#relay_' + recno).submit();
    };

    $scope.relay = function(form){
      var relayParams = '';
      if(form.fchar === 'X5B'){
        FormService.get1095BForms(form.recno).then(
          function(data){
            var x5b = data.result.Forms1095B;
            relayParams += 'PTIN=' + x5b.ptin + ',ACCOUNTNO=' + x5b.accountno + ',';
            relayParams += 'ORIGINOFPOLICY=' + x5b.originofpolicy + ',EMPLOYERSPONSOR=' + x5b.employersponsor;
            sendRelayRequest(relayParams, form.recno);
          },
          function(error){
            showUnassociatedDependentModal(error.data.error.frontend_code);
          }
        );
      }
      if(form.fchar === 'X5C'){
        FormService.get1095CForms(form.recno).then(
          function(data){
            var x5b = data.result.Forms1095C;
            relayParams += 'PTIN=' + x5b.ptin + ',ACCOUNTNO=' + x5b.accountno;
            sendRelayRequest(relayParams, form.recno);
          },
          function(error){
            showUnassociatedDependentModal(error.data.error.frontend_code);
          }
        );
      }
      setToken();
    };

    $scope.closeSidebar = function(){
      $scope.sidebar = false;
    };

    $scope.generateReport = function(typeReport){
      ReportService.generateReport(typeReport).then(function(data){
        if(data.result !== null){
          if(data.result.Status){
            $scope.token = $window.sessionStorage.token;
            $scope.filename = 'REPORT~' + UtilsService.splitFilename(data.result.FileName);
            $scope.shortfilename = UtilsService.splitFilename($scope.filename);
            $mdDialog.show({
              scope: $scope.$new(),
              templateUrl: 'app/views/createReports/modals/generating-report-file.html',
              parent: angular.element(document.body)
            });
            downloadReport();
          }
          else{
            $mdDialog.show({
              scope: $scope.$new(),
              templateUrl: 'app/views/createReports/modals/message-report.html',
              parent: angular.element(document.body)
            });
          }
        }
        else{
          $mdDialog.show({
            scope: $scope.$new(),
            templateUrl: 'app/views/createReports/modals/message-report.html',
            parent: angular.element(document.body)
          });
        }
      });
    };

    var setToken = function(){
      $scope.token = $window.sessionStorage.token;
    };

    var downloadReport = function(){
      var fileNameDate = UtilsService.getUnixTimestamp(new Date()).split(' ');
      fileNameDate[0] = $scope.shortfilename.replace('.xlsx', '_' + fileNameDate[0] + '.xlsx') ;
      $http({
            method: 'POST',
            url: 'html/rfm/download.html',
            data: $.param({token: $scope.token,rfm_filename: $scope.filename,rfm_shortfilename: $scope.shortfilename}),
            headers: {'Content-Type': 'multipart/form-data', 'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'},
            responseType: 'arraybuffer'
          }).success(function(data){
            var blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
            if(UtilsService.isInternetExplorer('11')){
              window.navigator.msSaveBlob(blob, fileNameDate[0]);
            }
            else{
              var objectUrl = URL.createObjectURL(blob);
              var anchor = angular.element('<a/>');
              anchor.css({display: 'none'});
              angular.element(document.body).append(anchor);
              anchor.attr({
                href: objectUrl,
                target: '_blank',
                download: fileNameDate[0]
              })[0].click();
              anchor.remove();
            }
            $scope.closeModal();
          });
    };

    setToken();
  }
]);
